import { render, staticRenderFns } from "./BookSearch.vue?vue&type=template&id=faa4cd60&scoped=true"
import script from "./BookSearch.vue?vue&type=script&lang=js"
export * from "./BookSearch.vue?vue&type=script&lang=js"
import style0 from "./BookSearch.vue?vue&type=style&index=0&id=faa4cd60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa4cd60",
  null
  
)

export default component.exports